import { EmptyState as UiEmptyState } from '@Pages/pageRuntime/components/ui/EmptyState';
import type React from 'react';

type EmptyStateProps = {
  /**
   * Primary empty-state message.
   */
  title: string;

  /**
   * Short supporting explanation.
   */
  description: string;

  /**
   * Optional call to action element.
   */
  action?: React.ReactNode;

  /**
   * Whether to show the default icon.
   */
  showIcon?: boolean;
};

/**
 * A centered empty state for missing data, first-run states, or no results. Use when the
 * surrounding page has no meaningful records or results to show.
 *
 * @example
 * <Sdk.Components.EmptyState title="No students yet" description="Students will appear here after they are added." />
 */
export function EmptyState({ title, description, action, showIcon = true }: EmptyStateProps) {
  return (
    <div className="flex min-h-[240px] flex-col items-center justify-center gap-4">
      <UiEmptyState title={title} description={description} showIcon={showIcon} />
      {action ? <div>{action}</div> : null}
    </div>
  );
}
